function isScrolledIntoView(elem) {
  let docViewTop = jQuery(window).scrollTop();
  let docViewBottom = docViewTop + jQuery(window).height();

  let elemTop = jQuery(elem).offset().top;
  let elemBottom = elemTop + jQuery(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function addEvents(){
  jQuery('.singleExperience').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).find('.experienceImage').addClass('visibleElement');
      jQuery(this).find('.card-body').addClass('visibleElement');
    }
  });

  jQuery('.singleCircle').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).addClass('visibleElement');
      jQuery(this).find('.imageWrapper').addClass('visibleElement');
    }
  });

  jQuery('.singleBanner').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).addClass('visibleElement');
    }
  });

  jQuery('.text-and-video').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).find('.imageWrapper').addClass('visibleElement');
      jQuery(this).find('.textWrapper').addClass('visibleElement');
    }
  });

  jQuery('.image-and-text').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).find('.imageWrapper').addClass('visibleElement');
      jQuery(this).find('.textWrapper').addClass('visibleElement');
    }
  });

  jQuery('.text-and-image-discount').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).find('.imageWrapper').addClass('visibleElement');
      jQuery(this).find('.textWrapper').addClass('visibleElement');
    }
  });

  jQuery('div#gridWrapper.notSlider').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).find('.singleBanner').addClass('visibleElement');
    }
  });

  jQuery('.familiesWrapper').each(function() {
    if (isScrolledIntoView(jQuery(this))) {
      jQuery(this).find('.familyLink').addClass('visibleElement');
    }
  });
}

jQuery(document).on('scroll ready', function() {
addEvents()
})



// WEBPACK FOOTER //
// ./scripts/blocks/home.js